// Generated by ts-to-zod
import { z } from 'zod';

export const resetPasswordSchema = z.object({
  detail: z.unknown().optional(),
});
